<template>
  <div class="screenMain">
    <el-row>
      <el-col :span="6">
        <div class="leftMain">
          <!-- 搜索框以及按钮 -->
          <div class="search" @keyup.enter="exhibitSearch">
            <el-input :placeholder="$t('exhibition.placeholder')" class="input-with-select" v-model="keyWords">
              <el-button slot="append" @click="exhibitSearch()">
                <i class="el-icon-search"></i>
              </el-button>
            </el-input>
          </div>

          <!-- 按产品类型筛选 -->
          <div class="screen">
            <div class="screenTitle" @click="arrowToggle()">
              <div class="left" :title="screenList.title">
                {{ screenList.title }}
              </div>
              <!-- 右侧小箭头 -->
              <div class="right">
                <i class="el-icon-arrow-up" v-if="open"></i>
                <i class="el-icon-arrow-down" v-else></i>
              </div>
            </div>
            <!-- 按产品类型筛选的下级栏目列表显示与隐藏 -->
            <div class="screenCondition" :style="{ display: open ? 'block' : 'none' }">
              <!-- 按产品类型筛选的下级栏目列表 -->
              <ul>
                <li v-for="(i, k) in screenList.conditons" :key="k" class="hoverStyle" @mouseenter="hoverIn(k)" :title="i.title">
                  <el-checkbox @change="checkLi(i)" v-model="i.choose">{{ i.title }}</el-checkbox>
                </li>
              </ul>
            </div>
          </div>

          <!-- 按展馆筛选 -->
          <div class="exhibitionList">
            <div class="screenTitle" @click="arrowToggleEx()">
              <div class="left">
                {{ exhibitionList.title }}
              </div>
              <!-- 右侧的小箭头 -->
              <div class="right">
                <i class="el-icon-arrow-up" v-if="openEx"></i>
                <i class="el-icon-arrow-down" v-else></i>
              </div>
            </div>

            <!-- 折叠按展馆筛选的下级栏目 -->
            <div class="screenCondition" :style="{ display: openEx ? 'block' : 'none' }">
              <!-- 按展馆筛选的下级选项列表 -->
              <ul>
                <li v-for="(i, k) in exhibitionList.conditons" :key="k" style="float: left">
                  <el-checkbox @change="checkEx(i)" v-model="i.choose"> {{ i.title }}</el-checkbox>
                </li>
              </ul>
            </div>
          </div>

          <!-- 鼠标移入的时候右侧出现的面板信息------------------------------------------------------------------->
          <div
            class="secondCategory"
            id="secate"
            :style="{
              display: secordDisplay ? 'block' : 'none',
              zIndex: secordDisplay ? '10000' : '',
            }"
            @mouseleave="hoverOut()"
          >
            <el-card class="box-card">
              <div class="box" v-for="(ite, k) in secordList" :key="k">
                <div class="title1">
                  <el-checkbox @change="checkAlll(ite)" v-model="ite.choose">{{ ite.title }}</el-checkbox>
                </div>

                <div class="body">
                  <el-checkbox @change="checkChild(ite, item)" v-model="item.choose" v-for="(item, index) in ite.children" :key="index">{{
                    item.title
                  }}</el-checkbox>
                </div>
              </div>
            </el-card>
          </div>

          <!-- 鼠标移入的时候右侧出现的面板信息------------------------------------------------------------------------>
        </div>
      </el-col>

      <!-- 右边的内容框开始 -->
      <el-col :span="18">
        <div class="rightMain">
          <!-- 右侧顶部的筛选条件的 -->
          <div class="rightTitle" :style="{ display: dynamicTags.length > 0 ? 'block' : 'none' }">
            <!--筛选条件框-->
            <el-row class="selectt">
              <div class="text">{{ $t('common.screenConditions') }}</div>
              <!--tags标签 -->
              <div>
                <el-tag :key="k" v-for="(tag, k) in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)">
                  {{ tag.name }}
                </el-tag>
              </div>
              <!-- 清空按钮 -->
              <div class="clear">
                <el-button icon="el-icon-delete" type="primary" @click="clearTag()">{{ $t('common.clear') }}</el-button>
              </div>
            </el-row>
          </div>
          <!-- 右侧顶部的筛选框结束 -->

          <!-- 右侧的内容区域 -->
          <div class="rightContent" :style="{ marginTop: dynamicTags.length > 0 ? '20px' : '0' }" v-if="returnDate.length > 0">
            <!-- 右侧内容区域的子栏目开始 -->
            <div v-for="(item, k) in returnDate" :key="k" class="content" @click="goDetail(item.id)">
              <div class="vedio1">
                <div class="titleLogo">
                  <img :src="`${item.comCover.substr(0,4) == 'http' ?'':baseUrl}${item.comCover}`" alt="" v-if="item.comCover.includes('/')" />
                  <img src="../../../static/占位-展品-列表.png" alt="" v-else />
                </div>
                <div class="top"></div>
                <div class="main">
                  <div class="company">{{ lang == 'zh' ? item.companyNameC:item.companyNameE?item.companyNameE:item.companyNameC}}</div>
                  <div style="display:flex;justify-content:center;">
                    <span>{{ $t('exhibition.boothNum') }}</span>
                    <div class="number">{{item.hzBoothList[0] && item.hzBoothList[0].boothNum ? item.hzBoothList[0].boothNum :''}}</div>
                  </div>
                </div>
                <div class="fixed">
                  <div class="banner-btn">
                    <img src="../../../static/ico_vedio.png" alt="" />
                  </div>
                </div>
              </div>
              <div class="bottom">
                <div class="bottomLeft">{{ $t('common.more') }}</div>
                <div class="bottomRight">
                  <span class="nu1" @click.stop="consult(item)">
                    <img src="../../../static/consultingBlack.png" alt="" />
                    <div class="hoversty">{{ $t('common.consult') }}</div></span
                  >

                  <span class="nu2"
                    ><img
                      :src="item.collectStatus ? require('../../../static/collent_yello.png') : require('../../../static/collen1t.png')"
                      @click.stop="toggle(item)"
                    />
                    <div class="hoversty">{{ item.collectStatus ? $t('common.clearCollect') : $t('common.collectExhibition') }}</div></span
                  >
                </div>
              </div>
            </div>

            <!-- 右侧内容区域的子栏目结束  -->
          </div>
          <!-- 筛选提交为空 -->
          <div class="boxImg" v-else>
            <img src="../../../static/empty.png" alt="" />
            <div>{{ $t('exhibition.noexhibition') }}</div>
          </div>
        </div>
        <!--分页 -->
        <div class="pagination">
          <span>{{ $t('common.pagination', { allNum: allNum }) }}</span>
          <el-pagination
            v-if="pageshow"
            class="explore_right_pages"
            layout="prev, pager, next"
            :current-page="currentPage4"
            @current-change="handleCurrentChange"
            :page-size="18"
            :total="allNum"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { forMat } from '../../../../utils/common';
import { getexAll, getShoucang, selectHibit } from '../../../../api/exhibitor';
import * as tools from '../../../../utils/roulink';
// import * as funApi from "../../../../Json/exhiList_20210715"
import { screenList } from '../../../../Json/screenList';
import { screenListEn } from '../../../../Json/screenListEn.js';
export default {
  components: {},
  data() {
    return {
      baseUrl: forMat(),
      keyWords: '', // 路径上面的关键词
      currentPage4: 1,
      hoverIndex: '',
      //面板信息数组
      secordList: [],
      //控制面板信息
      secordDisplay: false,
      //按产品类型筛选
      screenList,
      //按展馆筛选
      exhibitionList: {
        title: this.$t('common.screen2'),
        conditons: [
          {
            id: '2-1',
            title: 'E1',
            choose: false,
          },
          {
            id: '2-2',
            title: 'E2',
            choose: false,
          },
          {
            id: '2-3',
            title: 'E3',
            choose: false,
          },
          {
            id: '2-4',
            title: 'E4',
            choose: false,
          },
          {
            id: '2-5',
            title: 'E5',
            choose: false,
          },
          {
            id: '2-6',
            title: 'E6',
            choose: false,
          },
          {
            id: '2-7',
            title: 'E7',
            choose: false,
          },
          {
            id: '2-8',
            title: 'W1',
            choose: false,
          },
          {
            id: '2-9',
            title: 'W2',
            choose: false,
          },
          {
            id: '2-10',
            title: 'W3',
            choose: false,
          },
          {
            id: '2-11',
            title: 'W4',
            choose: false,
          },
          {
            id: '2-12',
            title: '室外A区',
            choose: false,
          },
        ],
      },
      //控制按产品类型筛选的折叠收起
      open: true,
      //控制按展馆筛选的折叠收起
      openEx: true,
      tags: [],
      //右侧筛选框的tag标签
      dynamicTags: [],
      //   上传数据
      uploadForm: {
        page: '1',
        size: '18',
        value: {
          exhibitsType: [],
          hzBoothHall: [],
          keyword: '',
        },
      },
      // 返回的数据
      returnDate: [],
      // 总条数
      allNum: 18,
      pageshow: true,
    };
  },

  methods: {
    //   列表数据获取
    async getexhDet() {
      // console.log('上传数据', this.uploadForm.value.hzBoothHall);
      const data = await getexAll(this.uploadForm);
      this.allNum = data.data.data.count;
      if (data.data.data.list.length > 0) {
        this.returnDate = data.data.data.list;
        this.returnDate.forEach((item, i) => {
          if(item.comCover.indexOf("http")  == -1){
            this.returnDate[i].comCover= `${this.baseUrl}${this.returnDate[i].comCover}`;
          }
        })
        // console.log("展商数据",data);
      } else {
        this.returnDate = [];
      }
    },
    async exhibitSearch() {
      // 点击搜索按钮进行搜索
      var exhibitsType = [];
      // console.log("tag数据",this.dynamicTags);
      if (this.dynamicTags.length > 0) {
        var exhibitsType = []; //产品标签
        var hzBoothHall = []; //展商标签
        this.dynamicTags.map((item) => {
          var reg = RegExp(/-/);
          var str = reg.test(item.index);
          if (str) {
            hzBoothHall.push(item.name == '室外A区'? item.name:item.name.substring(0, 2));
          } else {
            exhibitsType.push(item.type);
          }
        });
      }
      this.uploadForm = {
        page: '1',
        size: '18',
        value: {
          exhibitsType: exhibitsType,
          keyword: this.keyWords,
          hzBoothHall: hzBoothHall,
        },
      };
      this.getexhDet();
    },
    //分页点击事件
    handleCurrentChange(val) {
      if (this.dynamicTags.length > 0) {
        var exhibitsType = []; //产品标签
        var hzBoothHall = []; //展商标签
        this.dynamicTags.map((item) => {
          var reg = RegExp(/-/);
          var str = reg.test(item.index);
          if (str) {
            hzBoothHall.push(item.name == '室外A区'? item.name:item.name.substring(0, 2));
          } else {
            exhibitsType.push(item.type);
          }
        });
      }
      this.uploadForm = {
        page: val,
        size: '18',
        value: {
          exhibitsType: exhibitsType,
          keyword: this.keyWords,
          hzBoothHall: hzBoothHall,
        },
      };
      this.getexhDet();
      console.log('当前页', val);
    },
    //产品类型筛选点击事件
    checkLi(i) {
      this.deSelect(i);
    },
    //展馆诗选筛选点击事件
    checkEx(i) {
      this.deSelect(i);
    },
    //取消选择
    deSelect(i) {
      if (i.choose) {
        i.title.length > 2
          ? this.dynamicTags.push({ index: i.id, name: i.title, type: i.type })
          : this.dynamicTags.push({ index: i.id, name: i.title + this.$t('common.hall') });
      } else {
        for (let item in this.dynamicTags) {
          console.log('999',item);
          i.id == this.dynamicTags[item].index ? this.dynamicTags.splice(item, 1) : console.log('失败');
        }
      }
    },

    //tags删除取消事件
    handleClose(tag) {
      if (tag.index.length <= 4) {
        const val = tag.name == '室外A区'? tag.name:tag.name.substring(0, 2);
        this.matchTag(val, this.exhibitionList.conditons);
        this.tagDel(tag);
      } else {
        this.matchTag(tag.name, this.screenList.conditons);
        this.tagDel(tag);

        this.matchTree(tag.name, this.screenList.conditons[this.hoverIndex].children);
      }
    },
    //tags左侧匹配事件
    matchTag(val, arr) {
      for (let i = 0; i < arr.length; i++) {
        if (val == arr[i].title) {
          arr[i].choose = false;
          return false;
        }
      }
    },
    //勾选tag标签后取消信息面板的勾选
    matchTree(tag, arr) {
      arr.forEach((item, i) => {
        const index = item.children.findIndex((i) => {
          return i.title == tag;
        });
        index != -1 ? (arr[i].children[index].choose = false) : console.log('失败了啊！');
      });
    },
    //tag标签删除
    tagDel(tag) {
      for (let item in this.dynamicTags) {
        if (this.dynamicTags[item].index == tag.index) {
          this.dynamicTags.splice(item, 1);
        }
      }
    },
    //清空所有tags标签   -----存在小bug,全部删除时，信息面板勾选的没取消---------------------------------------
    clearTag() {
      this.dynamicTags = [];
      //清空按产品类型筛选
      this.screenList.conditons.forEach((element) => {
        element.choose = false;
        element.children.forEach((i) => {
          i.choose = false;
          i.children.forEach((v) => {
            v.choose = false;
          });
        });
      });
      //清空按展馆筛选
      this.exhibitionList.conditons.forEach((element) => {
        element.choose = false;
      });
      //清空面板
      this.secordList = [];
    },
    //产品类型筛选的鼠标移入事件
    hoverIn(index) {
      this.hoverIndex = index;
      this.secordDisplay = true;
      this.secordList = [];
      this.secordList = this.screenList.conditons[index].children;
    },

    //面板全选
    checkAlll(item) {
      // console.log(item);
      if (item.choose) {
        item.children.map((item) => {
          item.choose = true;
          this.dynamicTags.push({ index: item.id, name: item.title, type: item.type });
          this.dynamicTags = this.unique(this.dynamicTags);
        });
      } else {
        item.children.forEach((i) => {
          i.choose = false;
          const index = this.dynamicTags.findIndex((k) => {
            return i.title == k.name;
          });
          this.dynamicTags.splice(index, 1);

          this.dynamicTags = this.unique(this.dynamicTags);
        });
      }
    },
    unique(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.name) && res.set(arr.name, 1));
    },
    checkChild(arr, item) {
      if (item.choose) {
        this.dynamicTags.push({ index: item.id, name: item.title, type: item.type });

        const flag = arr.children.every((i) => {
          return i.choose == true;
        });
        flag ? (arr.choose = true) : console.log('');
      } else {
        const index = this.dynamicTags.findIndex((i) => {
          return i.name == item.title;
        });
        this.dynamicTags.splice(index, 1);
        const flag = arr.children.some((i) => {
          return i.choose == true;
        });
        flag ? (arr.choose = false) : console.log('');
      }
    },

    //产品类型筛选的鼠标移出事件
    hoverOut() {
      this.secordDisplay = false;
    },
    //折叠按钮
    arrowToggle() {
      this.open = !this.open;
    },
    //折叠按钮
    arrowToggleEx() {
      this.openEx = !this.openEx;
    },
    //点击咨询进行登陆判断
    consult(item) {
      // console.log("点击了咨询");
      // const isToken = localStorage.getItem('viewToken'); //观众
      //  item.id 展商id
      tools.login(1, item.id);
    },

    //根据首页拿到参数进行查询
    async getSearchHib(params) {
      console.log('被拦截的参数', params);
      const { data } = await selectHibit(params);
      this.allNum = data.data.count;
      //  console.log("从首页跳转到展商之后的查询",data);
      if (data.data.list.length > 0) {
        this.returnDate = data.data.list;
        this.returnDate.forEach((item, i) => {
          if(item.comCover.indexOf("http")  == -1){
            this.returnDate[i].comCover= `${this.baseUrl}${this.returnDate[i].comCover}`;
          }
        })
      } else {
        this.returnDate = [];
      }
    },
    //跳转
    goDetail(id) {
      this.$router.push({
        name: 'exhibition_det',
        query: {
          id,
        },
      });
    },
    //判断点击收藏状态
    async toggle(item) {
      const shouDetail = {
        objId: item.id,
        flag: !item.collectStatus,
        type: 1,
      };
      try {
        const data = await getShoucang(shouDetail);
        if (data.data.code === 200) {
          item.collectStatus = !item.collectStatus;
          if (item.collectStatus) {
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'error',
            });
          }
        } else {
          // this.$message({
          //   showClose: true,
          //   message: data.data.msg,
          //   type: 'warning',
          // });
          tools.login(3);
        }
      } catch (err) {
        console.log(err);
      }
    },
    clickOutside() {
      var btn = document.querySelector('.secondCategory');
      if (btn) {
        if (!btn.contains(event.target)) {
          this.secordDisplay = false;
        }
      }
    },
  },
  mounted() {
    window.addEventListener('click', this.clickOutside);
  },
  watch: {
    keyWords(newValue, oldValue) {
      this.keyWords = newValue;
    },
    dynamicTags(newValue, oldValue) {
      var exhibitsType = []; //产品标签
      var hzBoothHall = []; //展商标签
      newValue.map((item) => {
        var reg = RegExp(/-/);
        var str = reg.test(item.index);
        if (str) {
          hzBoothHall.push(item.name == '室外A区'? item.name:item.name.substring(0, 2));
        } else {
          exhibitsType.push(item.type);
        }
      });
      this.uploadForm = {
        page: '1',
        size: '18',
        value: {
          exhibitsType: exhibitsType,
          keyword: this.keyWords,
          hzBoothHall: hzBoothHall,
        },
      };
      const hallKeywords = this.uploadForm.value.hzBoothHall;
      const type = this.uploadForm.value.exhibitsType;
      const strHall = hallKeywords.toString();
      const strType = type.toString();
      this.$router.push({
        query: { screenHall: strHall, type: strType },
      });
      this.currentPage4 = 1;
      this.pageshow = false;
      this.getexhDet();
      this.$nextTick(() => {
        this.pageshow = true;
      });
    },
    'uploadForm.value.hzBoothHall': {
      handler: function(newValue) {
        if (newValue.length == 0) {
          const href = window.location.href;
          var arr = href.split('');
          const hallIndex = href.indexOf('screenHall=');
          if (hallIndex != -1) {
            if (arr[hallIndex - 1] === '?') {
              // hall在前
              arr.splice(hallIndex, 12);
            } else {
              arr.splice(hallIndex - 1, 12);
            }
          }
          const str = arr.join('');
          window.location.href = str;
        }
      },
    },
    'uploadForm.value.exhibitsType': {
      handler: function(newValue) {
        if (newValue.length == 0) {
          const href = window.location.href;
          var arr = href.split('');
          const typeIndex = href.indexOf('type=');
          if (typeIndex != -1) {
            if (arr[typeIndex - 1] === '?') {
              // type在前
              arr.splice(typeIndex, 6);
            } else {
              arr.splice(typeIndex - 1, 6);
            }
          }
          const str = arr.join('');
          window.location.href = str;
        }
      },
    },
  },
  created() {
    // this.jsonDetail()
    this.lang = localStorage.getItem('lang');
    const lang = this.lang
    if (lang == 'en') {
      this.screenList = screenListEn;
    } else {
      this.screenList = screenList;
    }
    const href = window.location.href;
    if (this.$route.query.type) {
      // 筛选参数有type
      this.open = !this.open;
      const arr = this.$route.query.type.split(',');
      arr.map((item) => {
        this.screenList.conditons.map((i) => {
          if (item === i.type) {
            i.choose = true;
            this.dynamicTags.push({ index: i.id, name: i.title, type: i.type });
          }
        });
      });
    }
    if (this.$route.query.screenHall) {
      // 筛选参数有hall
      const arr = this.$route.query.screenHall.split(',');
      arr.map((item) => {
        this.exhibitionList.conditons.map((i) => {
          if (item === i.title) {
            i.choose = true;
            this.dynamicTags.push({ index: i.id, name: i.title + this.$t('common.hall') });
          }
        });
      });
      const params = {
        page: 1,
        size: 18,
        value: {
          hzBoothHall: arr,
        },
      };
      this.getSearchHib(params);
    }

    if (this.$route.query.exhibitsType != null) {
      const arr = decodeURI(href).split('?');
      const newArr = arr[1].split('&');
      // 类型
      let type;
      if (newArr[0].includes('=')) {
        type = newArr[0].split('=');
        if (this.$route.query.exhibitsType == 0 || type[1] == '') {
          type = '';
        }
      } else {
        type = '';
      }

      let keyword;
      // 关键字
      if (newArr[1]) {
        keyword = newArr[1].split('=')[1];
      } else {
        keyword = '';
      }

      if (type != '') {
        const params = {
          page: 1,
          size: 18,
          value: {
            exhibitsType: type,
            keyword: keyword,
          },
        };
        console.log('执行的第一个');
        this.getSearchHib(params);
      } else {
        const params = {
          page: 1,
          size: 18,
          value: {
            keyword: keyword,
          },
        };

        console.log('执行展商的无类型的数据的查询');
        this.getSearchHib(params);
      }
    }
    const length = Object.keys(this.$route.query).length;
    if (length == 0) {
      this.getexhDet();
    }
  },
};
</script>
<style lang="scss" scoped>
.screenMain {
  width: 100%;
  .leftMain {
    margin-top: 20px;
    width: 295px;
    // border: 1px solid rgb(0, 0, 0);
    .search {
      width: 100%;
      height: 40px;
      .input-with-select {
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        color: #999999;
        .el-button {
          width: 70px;
          height: 40px;
          background: #006fb8;
          border-radius: 0px 4px 4px 0px;
          font-size: 16px !important;
          i {
            width: 24px;
            height: 24px;
            color: white;
          }
        }
      }
    }

    .screen {
      margin-top: 20px;
      width: 100%;
      position: relative;
      .screenTitle {
        width: 100%;
        height: 50px;
        background: #006fb8;
        padding: 0 14px 0 30px;
        line-height: 50px;
        box-sizing: border-box;
        display: inline-block;
        .left {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          float: left;
          width: 220px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .right {
          float: right;
          width: 24px;
          height: 24px;
          color: white;
        }
      }
      .screenCondition {
        width: 100%;
        background-color: white;
        ul {
          padding-bottom: 10px;
          box-sizing: border-box;
        }
        li {
          padding: 0;
          margin: 0;
          list-style: none;
          .el-checkbox {
            margin-left: 30px;
            line-height: 40px;
            height: 40px;
          }
        }
        ul li:hover {
          background: #f4f4f4;
          .el-checkbox {
            color: #006fb8;
          }
        }
        ul li:hover:before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 40px;
          line-height: 40px;
          opacity: 1;
          background: #fccf00;
          position: absolute;
        }
        ul li:hover .secondCategory {
          display: block;
        }
      }
    }
    .exhibitionList {
      margin-top: 20px;
      width: 100%;
      position: relative;
      .screenTitle {
        width: 100%;
        height: 50px;
        background: #006fb8;
        padding: 0 14px 0 30px;
        line-height: 50px;
        box-sizing: border-box;
        display: inline-block;
        .left {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          float: left;
        }
        .right {
          float: right;
          width: 24px;
          height: 24px;
          color: white;
        }
      }
      .screenCondition {
        width: 100%;
        background-color: white;
        float: left;
        ul {
          padding-bottom: 10px;
          box-sizing: border-box;
          width: 95%;
        }
        li {
          padding: 0;
          margin: 0;
          width: 81px;
          list-style: none;
          .el-checkbox {
            margin-left: 30px;
            line-height: 40px;
            height: 40px;
          }
        }
        ul li:hover .secondCategory {
          display: block;
        }
      }
    }
    .secondCategory {
      position: absolute;
      left: 295px;
      top: 80px;
      display: none;
      // border: 1px solid red;
      z-index: 1222222;
      width: 750px;
      min-height: 484px;
      height: auto;

      .box-card {
        width: 100%;
        // height: auto;
        min-height: 484px;
        // background-color: skyblue;
        .box {
          width: 100%;
          // border: 1px solid red;
          margin-bottom: 20px;
          .title1 {
            padding-bottom: 5px;
            margin-bottom: 18px;
            border-bottom: 1px solid #e0e0e0;
            .el-checkbox {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #333333;
            }
          }
          .body {
            .el-checkbox {
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
  .rightMain {
    margin-top: 20px;
    .rightTitle {
      width: 100%;
      // border: 1px solid red;
      .selectt {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .disp {
          margin-left: 11px;
        }
        .clear {
          margin-left: 11px;
          button {
            margin-bottom: 9px;
          }
        }
      }

      .text {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
      }
      .el-button--primary {
        width: 80px;
        height: 40px;
        background: #006fb8;
        border-radius: 4px;
        text-align: center;
      }
      .myList {
        display: inline-block;
      }
      ul li {
        display: inline;
      }
    }
    .rightContent {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      width: 981px;
      .content {
        margin-bottom: 30px;
        width: 295px;
        height: 312px;
        background-color: #ffffff;
        border: 1px solid #e0e0e0;
        box-shadow: 0px 0px 51px 0px #e8ecf0;
        position: relative;
        margin-right: 30px;
        .vedio1 {
          .top {
            width: 100%;
            height: 100px;
          }
          .fixed {
            width: 100%;
            height: 77%;
            position: absolute;
            top: 0;
            background-color: rgba(30, 30, 30, 0.3);
            display: none;
            z-index: 1;
            img {
              margin: 88px 123.5px;
            }
          }
          .main {
            width: 295px;
            height: 140px;
            background-color: rgba(76, 179, 254, 0.11);
            padding-top: 62px;
            box-sizing: border-box;
            text-align: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            display: flex;
            flex-direction: column;
            justify-content: space-around;

            span {
              margin-top: 13px;
              color: #333;
            }
            .company {
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 800;
              color: #333333 !important;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              margin: 0px 10px;
              word-break: break-all;
            }
            .number {
              display: inline-block;
              /*   color: #fdd000; */
              color: #333333;
              font-weight: 600;
              margin-top: 13px;
              margin-left: 10px;
            }
          }
          .titleLogo {
            width: 255px;
            height: 109px;
            background: #ffffff;
            box-shadow: 0px 0px 51px 0px #e8ecf0;
            position: absolute;
            top: 31px;
            left: 20px;
            padding: 0 15px;
            box-sizing: border-box;
            text-align: center;
            line-height: 109px;
            align-items: center;

            img {
              max-width: 100%;
              max-height: 100%;
              vertical-align: middle;
            }
          }
        }
        .bottom::after {
          content: '';
          display: block;
          height: 0;
          visibility: hidden;
          clear: both;
        }
        .bottom {
          padding-top: 17px;
          padding-left: 24px;
          padding-right: 24px;
          box-sizing: border-box;
          .bottomLeft {
            padding-top: 10px;
            box-sizing: border-box;
            float: left;
            font-size: 16px;
            cursor: pointer;
          }
          .bottomRight {
            float: right;
            display: flex;
            .nu1 {
              display: block;
              img {
                cursor: pointer;
              }
              .hoversty {
                width: 96px;
                height: 40px;
                background: #000000;
                opacity: 0.7;
                border-radius: 4px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #ffffff;
                display: none;
                text-align: center;
                padding-top: 2px;
                position: absolute;
                right: -35px;
                bottom: 16px;
                border-radius: 10px;
                cursor: pointer;
                line-height: 40px;
                z-index: 99;
              }
            }
            .nu1:hover .hoversty {
              display: block;
            }
            .nu2 {
              img {
                cursor: pointer;
              }
              .hoversty {
                width: 96px;
                height: 40px;
                background: #000000;
                opacity: 0.7;
                border-radius: 4px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #ffffff;
                display: none;
                text-align: center;
                position: absolute;
                right: -70px;
                bottom: 16px;
                border-radius: 10px;
                cursor: pointer;
                line-height: 40px;
                z-index: 99;
              }
            }
            .nu2:hover .hoversty {
              display: block;
            }
          }
        }
      }
      // .vedio1:hover > .fixed {
      //   display: block;
      // }
    }
  }
  .pagination {
    display: flex;
    justify-content: center;
    margin: 20px 0 61px;
    span {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      margin-top: 9px;
    }
  }
}
</style>

<style lang="scss" scoped>
.el-tag {
  margin-left: 10px !important;
  margin-bottom: 10px !important;
  height: 40px !important;
  line-height: 40px !important;
}
::v-deep .explore_right_pages {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-pagination button:hover {
    color: #978d8d;
  }
  .el-pagination button {
    color: #999999;
  }

  .el-pager li {
    background-color: unset;
  }
  .el-pager li:hover {
    color: #999999;
  }
  .btn-prev {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
    margin-left: 10px;
  }
  .btn-next {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
  }
  .el-pager .number {
    width: 32px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #cccccc;
    margin-right: 5px;
    margin-right: 5px;
    color: #999999;
  }
  .el-pager .number:hover {
    color: #006fb8;
  }
  .el-pager li.active {
    border: none;
    cursor: pointer;
    background: #006fb8;
    color: #fff;
  }
  .el-pager li.active:hover {
    color: #fff;
    background: #006fb8;
  }
  .el-pager li.btn-quicknext {
    line-height: 28px;
    color: #999;
  }
}

::v-deep .screen .el-checkbox__label,
::v-deep .exhibitionList .el-checkbox__label {
  font-size: 16px;
}
</style>
<style scoped>
.search >>> .el-form-item__label {
  font-size: 16px;
}
.search >>> .el-input__inner {
  font-size: 16px;
}
>>> .el-checkbox__label {
  display: inline-block;
  padding-left: 10px;
  line-height: 20px;
  font-size: 14px;
  white-space: nowrap;
  width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
</style>

<style scoped>
.boxImg {
  margin: 0 auto;

  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.boxImg img {
  width: 380px;
  height: 300px;
}
</style>
